import { doc } from "prettier";

export default (function () {

  /**
   * TOC list
   *
   */

  const toc = document.querySelector('.js-toclist');

  if (toc != null && toc != undefined) {
    const content = document.querySelector('.p-single__main');
    const content_heading = content.querySelectorAll('h2,h3');
    const heading_array = new Array(); //閲覧中の見出しを入れるための配列


    // リストにリンク、タイトルを追加する
    // ---------------------------------------------------------
    content_heading.forEach((heading,index) => {
      let text = heading.textContent;
      heading.setAttribute('id', 'webliker-toc-' + index);

      let li = document.createElement('li');
      let link = document.createElement('a');
      link.textContent = text;
      link.setAttribute('href', `#webliker-toc-${index}`);

      li.appendChild(link);

      if (heading.nodeName == 'h2' || heading.nodeName == 'H2') {
        li.classList.add('h2');
      } else {
        li.classList.add('h3');
      }

      toc.appendChild(li);

      // heading_array[`${index}`] = `#webliker-toc-${index}`;
      heading_array[`#webliker-toc-${index}`] = heading.offsetTop;

    });



    // スクロールした時に閲覧中に見出しを取得・表示
    // ---------------------------------------------------------

    const options = {
      root: null,
      rootMargin: "-50% 0px", // ビューポートの中心を判定基準にする
      threshold: 0 // 閾値は0
    };
    const observer = new IntersectionObserver(inviewHeadline, options);
    
    const current_title = document.querySelector('.js-currenttitle');
    const headline = document.querySelectorAll(`[id^='webliker-toc']`);

    headline.forEach(h => {
      observer.observe(h);
    });

    function inviewHeadline(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          
          // 現在の見出しの変更
          var text = entry.target.innerText;
          current_title.textContent = text;
          current_title.animate([{opacity: '0'}, {opacity: '1'}], 300);

          // 現在の見出しをハイライト
          var current_id = entry.target.id;
          toc.querySelectorAll('li').forEach((li) => {
            li.classList.remove('is-current');
          });
          toc.querySelector('[href="#' + current_id + '"]').parentNode.classList.add('is-current');
        
        }
      });
    }

  }
})();
